module.exports = __webpack_public_path__ + "img/综合平台_xz.174e1cb2.jpg";